import { ErrorHandler, Service } from '@angular/core';

import { recordError } from './diagnostics';

@Service({ autoProvided: false })
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    recordError('runtime', error);
  }
}
